/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { getSignalsListCached } from '../../../../../stores/signals-main/signals/getters';
import { getMomentFromTimestamp } from '../../../../../utils';
import { useHistory } from 'react-router-dom';
import { saveSignalsListLocation } from '../helpers/save-and-send-location';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    justifyContent: 'center',
  },
}));

const CellDateCreated = ({ row = {} }) => {
  const classes = useStyles();
  const { original = {} } = row;
  const { _id = '' } = original;
  const history = useHistory();

  const createdAt = useSelector((state) => {
    const { createdAt = '' } =
      getSignalsListCached(state).find((d) => d._id === _id) || {};

    return createdAt;
  });

  const formattedDate = getMomentFromTimestamp(createdAt).format('DD/M/YYYY');

  const handleRedirectToEdit = () => {
    saveSignalsListLocation();

    history.push(`/signals/${_id}`, {
      from: window.location.hash,
    });
  };

  return (
    <div className={classes.root} onClick={handleRedirectToEdit}>
      {formattedDate}
    </div>
  );
};

export default CellDateCreated;
